import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { LaboratorioNuevo } from './LaboratorioNuevo';
import { LaboratorioPrevio } from './LaboratorioPrevio';
import { LaboratorioEditar } from './LaboratorioEditar';
import { Forbidden } from '../../../components';

import styles from '../PacienteConsulta.module.css';

export const Laboratorio = () => {

    let { id } = useParams();

    const { permisos } = useSelector(state => state.auth);

    let defaultTab = 4;

    if(permisos.laboratorioCreate){
        defaultTab = 1;
    }else if(permisos.laboratorioRead){
        defaultTab = 2;
    }

    const [tab, setTab] = useState(defaultTab);

    const [laboratorioActual, setLaboratorioActual] = useState({});

    return (
        <>
            <div className="row">
                <div className="col">
                    <div className={styles.tabsSubHeader}>Laboratorios</div>
                    <div  className={styles.tabsContainerInner + " mt-3"}>
                        <div className={"row"}>
                            {(permisos.laboratorioCreate) &&
                            <div className="col p-0 text-center">
                                <div className={ (tab === 1) ? styles.tabActiveInner : styles.tabInner } onClick={() => setTab(1)}>Nuevo</div>
                            </div>
                            }
                            {(permisos.laboratorioRead && (!permisos.laboratorioUpdate || tab !== 3)) &&
                            <div className="col p-0 text-center">
                                <div className={ (tab === 2) ? styles.tabActiveInner : styles.tabInner } onClick={() => setTab(2)}>Previos</div>
                            </div>
                            }
                            {(permisos.laboratorioUpdate && tab === 3) &&
                            <div className="col p-0 text-center">
                                <div className={ styles.tabActiveInner }>Editar</div>
                            </div>
                            }
                        </div>
                    </div>
                    <div className={styles.tabsContentContainerInner}>
                        { (permisos.laboratorioCreate && tab === 1) && <LaboratorioNuevo id={id} /> }
                        { (permisos.laboratorioRead && tab === 2) && <LaboratorioPrevio id={id} editar={() => setTab(3)} setLaboratorioActual={setLaboratorioActual} /> }
                        { (permisos.laboratorioUpdate && tab === 3) && <LaboratorioEditar id={id} laboratorioData={laboratorioActual} cancelar={() => setTab(2)} /> }
                        { (tab === 4) && <Forbidden /> }
                    </div>
                </div>
            </div>
        </>
    )
}
